import ClassSelector from "./classSelector";
import { useEffect, useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { Icon } from "@iconify/react/dist/iconify.js";
import settingsIcon from '@iconify/icons-solar/settings-linear';
import adminIcon from '@iconify/icons-solar/crown-star-outline';
import logoutIcon from '@iconify/icons-solar/logout-2-outline';


const ME_QUERY = gql`
    query Me {
        me {
            ... on Teacher {
                id
                username
                surname
                lastname
                classes {
                    id
                    name
                }
            }
            ... on Admin {
                id
                username
                surname
                lastname
            }
        }
    }
`;

export default function TeacherHeader({ selectedClass, setSelectedClass }) {
    const { data, loading, error } = useQuery(ME_QUERY);

    const user = data?.me;

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error loading user data: {error.message}</div>;

    //FIXME: Menu has dei paddings not in line with the content. MINOR ISSUE

    return (
        <nav className="bg-white shadow">
            <div className="container mx-auto ">
                <div className="p-2">
                    <div className="flex flex-row items-center w-full py-2 gap-3 text-slate-800">
                        <div className="min-w-[20%]">
                            <p>
                                <span className="text-primary text-xl">
                                    <span className="font-bold uppercase">
                                        {user.lastname}
                                    </span>{" "}
                                    {user.surname}
                                </span>
                            </p>
                            <p className="hidden md:block">
                                {user.__typename === 'Teacher' ? 'Lehrer' : 'Administrator'}
                            </p>
                        </div>
                        <div className="hidden md:block w-full px-2 carbon">
                            <div className="flex w-full lg:w-1/2">
                                <ClassSelector
                                    selectedClass={selectedClass}
                                    onClassChange={setSelectedClass}
                                    enableAllClasses={false}
                                />
                            </div>
                        </div>
                        <div className="ms-auto flex items-center gap-1">
                            <a href="/settings" className="transform rotate-180 p-4 hover:bg-neutral-100 rounded-full">
                                <Icon icon={settingsIcon} width="24" height="24"/>
                            </a>
                            {user.__typename === 'Admin' && 
                                <a href="/admin" className="transform p-4 hover:bg-neutral-100 rounded-full">
                                    <Icon icon={adminIcon} width="24" height="24"/>
                                </a>
                            }
                            <a href="/logout" className="transform rotate-180 p-4 hover:bg-neutral-100 rounded-full">
                                <Icon icon={logoutIcon} width="24" height="24"/>
                            </a>
                        </div>
                    </div>
                    <div className="block md:hidden w-full carbon">
                            <div className="flex w-full md:w-1/2">
                                <ClassSelector
                                    selectedClass={selectedClass}
                                    onClassChange={setSelectedClass}
                                    enableAllClasses={false}
                                />
                            </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}
